import React from "react";
import PropTypes from "prop-types";
import styles from "./CarouselLink.css";
import classnames from "classnames";
import { truncateTitle } from "../../../../../../helpers/formatting";
import { getBackgroundImageUrl } from "../../../../../helpers/navigationBackgroundImageResolver";
import { addAnalyticsDataToLink } from "../../../../../helpers/addAnalyticsDataToLink";
import LazyImage from "../../../../LazyImage";

const cx = classnames.bind(this);

const CarouselLink = ({ item, className, tabIndex = 0 }) => {
  return (
    <li className={cx(styles.container, className)}>
      <LazyImage
        href={addAnalyticsDataToLink(item)}
        className={styles.carouselLink}
        tabIndex={tabIndex}
        src={getBackgroundImageUrl(item.smallAndMediumImageUrl, 320)}
        tag={"a"}
      >
        <p
          className={cx(styles.label, {
            [styles.label__sale]: item.smallAndMediumStyleType === "sale",
            [styles.label__light]: item.smallAndMediumStyleType === "light"
          })}
        >
          {item.smallAndMediumStyleType !== "noTitle" && (
            <span>{truncateTitle(item)}</span>
          )}
          {item.subtitle && (
            <span className={styles.subtitle}>
              {item.subtitle.substring(0, 24)}
            </span>
          )}
        </p>
      </LazyImage>
    </li>
  );
};

CarouselLink.propTypes = {
  item: PropTypes.object.isRequired,
  className: PropTypes.string,
  tabIndex: PropTypes.number
};

export default CarouselLink;
